import axios from 'axios';

const {REACT_APP_APIROOT, REACT_APP_API_TOKEN_APPLICATION,REACT_APP_BACKEND_ENDPOINT} = process.env;

const api = axios.create({
    baseURL: `${window.location.protocol}//${window.location.hostname}/api/` + REACT_APP_APIROOT + REACT_APP_BACKEND_ENDPOINT,
    headers: {
        'Content-Type': "application/json",
        'X-POB-Application': REACT_APP_API_TOKEN_APPLICATION
    },
    Accept: "application/json"
});
 
const apiClient = {
    post: async (requestBody = {}, headers = {}) => {
        try {
            let response = await api.post('', requestBody, { headers });
            return response;
        } catch (error) {
            console.error('API post request failed', error);
            throw error;
        }
    },
};
 
export default apiClient;
